<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import { getList, add, del, update, getRule } from "@/api/user/b2b_cost";
import { getAllClient } from "@/api/user/client";
import { getCountry } from "@/api/system/country";
import { getChargingType, getService, getContacts} from "@/api/double/list";
import { getMethod } from "@/api/system/method";
import { getCategory } from "@/api/storage/category";

import cTable from "@/base/common/index";
import { getExpense } from "@/api/finance/expense";
import { getAgent } from "@/api/tracker/agent";
import { getSubjectCost } from "@/api/tracker/cost_page";
import { getCurrency } from "@/api/finance/currency";

export default {
  name: "b2b_feright",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        list: (p) => {
          return getList(p);
        },
        add,
        del,
        update,
        getAllClient,
				getRule,
				getAgent
      },
      selectData: {},
      config: {
        height: 630,
        addData: {},
      },
      modals: {
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              data["details"] = JSON.parse(JSON.stringify(this.list));
              this.$page.handleRequestMethods(this.type, data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 60,
              draggable: true,
            },
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              title: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              agent_id: [
                {
                  required: true,
                  type: "array",
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
              is_def: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            { agent_id: 24 },
            { title: 12, is_def: 12 },
            { remarks: 24 },
          ],
          fields: [
            {
              name: () => this.$t("agentT"),
              key: "agent_id",
              component: "Select",
              bind: {
                "max-tag-count": 5,
              },
              placeholder() {
                return this.$t("select") + this.$t("agentT");
              },
              config: { label: "agent_name", value: "id" },
              show: ({ row }) => {
                return !row.id;
              },
							default:[],
							bind:{
								multiple:true,
							},
							config:{
								label({row}){
									return row.code + '-' +row.alias
								},
								value:'id'
							},
							options:[],
							methods:{
								list:({field})=>{
									field.option = this.selectData['agent_id']
								}
							}
            },
            {
              name: () => this.$t("labelName"),
              key: "title",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("labelName");
              },
            },
            {
              name: () => this.$t("is_def"),
              key: "is_def",
              component: "Radio",
              options: [
                { label: this.$t("YES"), value: 1 },
                { label: this.$t("NO"), value: 2 },
              ],
              default: 2,
              bind: {
                border: true,
              },
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
              component: "Input",
              bind: {
                type: "textarea",
                rows: 3,
              },
            },
          ],
          table: {
            config: {
              height: 300,
            },
            fields: [
              {
                type: "btns",
                width: 160,
                name: () => this.$t("operation"),
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("add"),
                    type: "add",
                    fnName: "add",
                    bind: {
                      type: "warning",
                    },
                    icon: "md-add",
                    disabled({ rowIndex }) {
                      return rowIndex != 0;
                    },
                  },
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "delete",
                    icon: "md-trash",
                    disabled() {
                      return this.list.length == 1;
                    },
                  },
                ],
                methods: {
                  add() {
                    this.getModal("add").list.unshift({
                      expense_item: [],
                      amount: 0,
                      currency: "",
                    });
                    // let data = JSON.parse(
                    //   JSON.stringify(this.getModal("add").params)
                    // );
                    // this.getModal("add").updateFormData(data);
                  },
                  delete({ rowIndex }) {
                    this.$Modal.confirm({
                      title: this.$t("delete"),
                      width: 300,
                      content: this.$t("titleModal"),
                      onOk: () => {
                        this.getModal("add").list.splice(rowIndex, 1);
                      },
                    });
                  },
                },
              },
              // {
              //   name: () => this.$t("category_name"),
              //   align: "left",
              //   placeholder() {
              //     return this.$t("select") + this.$t("category_name");
              //   },
              //   component: "Select",
              //   bind: {
              //     style: "width:100%",
              //     type: "number"
              //   },
              //   config: {
              //     label: "name",
              //     value: "id"
              //   },
              //   methods: {
              //     async list({ field }) {
              //       field.options = (await getCategory()).data.payload;
              //       this.$forceUpdate();
              //     }
              //   }
              // },
              {
								name: () => this.$t("expense"),
								key: "expense_item",
								component: "Cascader",
								placeholder() {
									return this.$t("select") + this.$t("expense");
								},
								default:[],
								options1:[],
								methods: {
									list:({field})=>{
										field.options = field.options1
									},
									async loadData({ item, callback,row }) {
										item.loading = true;
										item.children = (
										  await getSubjectCost({ pid: item.value })
										).data.payload;
										item.loading = false;
										callback();
									},
								},
							},
              {
                name: () => this.$t("currencyCode"),
                align: "left",
                key: "currency",
                placeholder() {
                  return this.$t("select") + this.$t("currencyCode");
                },
                component: "Select",
                bind: {
                  style: "width:100%",
                },
								config: {
								  label: "title",
								  value: "code",
								},
								options:[],
								only:true,
                methods: {
									list({ field }) {
										getCurrency().then((res) => {
											if (res.data.status) {
												field.options = res.data.payload.rows;
											}
										});
									},
								},
              },
              {
                name: () => this.$t("reChAmount"),
                align: "center",
                key: "amount",
                placeholder() {
                  return this.$t("enter") + this.$t("reChAmount");
                },
                component: "InputNumber",
                bind: {
                  style: "width:100%",
                  step: 0.01,
                },
              },
              {
                name: () => this.$t("Remarks"),
                align: "center",
                key: "remarks",
                placeholder() {
                  return this.$t("enter") + this.$t("Remarks");
                },
                component: "Input",
                bind: {
                  style: "width:100%",
                },
              },
            ],
          },
        },
      },
      header: {
        config: {
          custom: false,
        },
        searchs: [
          {
            key: "agent_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("agentT");
            },
            clearable: true,
            options: [],
						config:{
							label({row}){
								return row.code + '-' +row.alias
							},
							value:'id'
						}
          },
          {
            key: "is_def",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("is_def");
            },
            clearable: true,
            options: [
              { label: this.$t("YES"), value: 1 },
              { label: this.$t("NO"), value: 2 },
            ],
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning",
              },
              id: 1233,
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, function () {
                this.list = [
                  {
                    expense_item: [],
                    amount: 0,
                    currency: "",
                    remarks: "",
                  },
                ];
                this.setTitle(this.$t("add"));
                this.type = "add";
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
        },
        {
          name: () => this.$t("labelName"),
          key: "title",
          align: "left",
          minWidth: 100,
          tooltip: true,
        },
        {
          name: () => this.$t("agentName"),
          key: "agent_name",
          minWidth: 80,
        },
        {
          name: () => this.$t("is_def"),
          key: "is_def",
          minWidth: 80,
          methods: {
            render({ value }) {
              let options = [
                { label: this.$t("YES"), value: 1 },
                { label: this.$t("NO"), value: 2 },
              ];
              return options.find((item) => item.value == value).label;
            },
          },
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          minWidth: 100,
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            // {
            //   name: () => this.$t("copy"),
            //   type: "copy",
            //   fnName: "copy",
            //   bind: {
            //     type: "warning",
            //   },
            // },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
              id: 1234,
            },

            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 1235,
            },
          ],
          methods: {
         //    copy({ row }) {
         //      let data = JSON.parse(JSON.stringify(row));
         //      delete data.id;
         //      delete data.client_id;
         //      this.getModal("add").open(data, function () {
         //        this.list = [
         //          {
         //            expense_item: [1,12],
         //            amount: 0,
         //            currency: "",
         //            remarks: "",
         //          },
         //        ];
         //        if (data.details.length > 0) {
         //          data.details.map((item) => {
         //            delete item.id;
         //            return item;
         //          });
									// this.$nextTick(()=>{
									// 	this.list = data.details;
									// })
         //        }
         //        this.setTitle(this.$t("copy"));
         //        this.type = "add";
         //      });
         //    },
            update({ row }) {
              let data = JSON.parse(JSON.stringify(row));
							this.$nextTick(()=>{
								this.getModal("add").open(data, function () {
								  this.setTitle(this.$t("update"));
								  this.type = "update";
									this.$nextTick(()=>{
										if (data.details.length > 0) this.list.push(...data.details);
										this.$refs['table'].$forceUpdate()
									})
								});
							})
              
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
  activated() {
    let searchForm = this.$refs["table"].$refs["header"].searchForm;
    searchForm.keywords = this.$store.state.user.pageUrl.label;
    searchForm.client_id = this.$store.state.user.pageUrl.client_id;
    this.$store.state.user.pageUrl = {};
    this.$refs["table"].getList();
  },
  async mounted() {
		let dingcang_company = (await getContacts()).data.payload;
    this.selectData = {
      // client_id: (await getAllClient()).data.payload.rows,
      // from_country: (await getCountry({ allow_depart: 1 })).data.payload.rows,
      // to_country: (await getCountry({ allow_arrive: 1 })).data.payload.rows,
      // transport_code: (await getMethod()).data.payload.rows,
      // service_code: (await getService()).data.payload,
			expense_item: (await getSubjectCost({ pid: 0 })).data.payload,
			agent_id:dingcang_company['ding']
    };
    this.modals.add.fields.forEach((item) => {
      if (item.key && this.selectData[item.key])
        item.options = this.selectData[item.key];
    });
		this.modals.add.table.fields.forEach((item) => {
		  if (item.key && this.selectData[item.key])
		    item.options1 = this.selectData[item.key];
		});
    this.header.searchs.forEach((item) => {
      if (item.key && this.selectData[item.key])
        item.options = this.selectData[item.key];
    });
  },
};
</script>
